var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "3de8dcf314d3224c9c782903a795d824.png",
    width: 1330,
    height: 1339
});